



































import Vue from 'vue';
import { FileUploadBox } from '@descomplica/vue-components';
import i18n from '@/i18n';

export interface SendDocumentsSponsorEvent {
  selfieSponsor: {
    fileName: string;
    fileDataUrl: string;
    isDocumentUploadDone?: boolean;
  };
  cpfSponsor: {
    fileName: string;
    fileDataUrl: string;
    isDocumentUploadDone?: boolean;
  };
  rgSponsor: {
    fileName: string;
    fileDataUrl: string;
    isDocumentUploadDone?: boolean;
  };
}

const FIVE_MB_IN_BYTES = 5 * 1024 ** 2;

export default Vue.extend({
  components: {
    FileUploadBox,
  },
  data() {
    return {
      sponsorFilesUploaded: 0,
      files: {
        selfieSponsor: {
          fileName: '',
          fileDataUrl: '',
          isDocumentUploadDone: false,
        },
        cpfSponsor: {
          fileName: '',
          fileDataUrl: '',
          isDocumentUploadDone: false,
        },
        rgSponsor: {
          fileName: '',
          fileDataUrl: '',
          isDocumentUploadDone: false,
        },
      } as SendDocumentsSponsorEvent,
      errorMessages: {
        selfieSponsor: '',
        cpfSponsor: '',
        rgSponsor: '',
      },
      maxFileSize: FIVE_MB_IN_BYTES,
    };
  },
  computed: {
    isJacadCourse(): boolean {
      return this.$store.getters.isJacadCourse;
    },
    visibleFiles(): SendDocumentsSponsorEvent | Omit<SendDocumentsSponsorEvent, 'selfieSponsor'> {
      if (this.isJacadCourse) {
        const { selfieSponsor, ...rest } = this.files;
        return rest;
      }
      return this.files;
    },
    totalFiles(): number {
      return Object.keys(this.visibleFiles).length;
    },
  },
  methods: {
    documentDeleteHandler(index: keyof SendDocumentsSponsorEvent) {
      this.files[index].fileName = '';
      this.files[index].fileDataUrl = '';
      this.files[index].isDocumentUploadDone = false;
      this.errorMessages[index] = '';
      this.sponsorFilesUploaded--;
      this.emitEvent();
    },
    documentUploadHandler(file: File, index: keyof SendDocumentsSponsorEvent) {
      this.errorMessages[index] = '';
      this.files[index].fileName = file.name;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.files[index].fileDataUrl = reader.result as string;
        this.files[index].isDocumentUploadDone = true;
        this.sponsorFilesUploaded++;
        this.emitEvent();
      };
    },
    errorHandler(error: 'type' | 'size', index: keyof SendDocumentsSponsorEvent) {
      this.errorMessages[index] = i18n.t(`fileUploadError.${error}`);
    },
    emitEvent() {
      const sentDocuments = Object.fromEntries(
        Object.entries(this.visibleFiles).filter(([, value]) => value?.isDocumentUploadDone),
      );

      const hasSentAllRequiredFiles = Object.entries(this.visibleFiles).every(([, value]) =>
        Boolean(value?.isDocumentUploadDone),
      );

      this.$emit('input', sentDocuments, hasSentAllRequiredFiles);
    },
  },
});
